import React from 'react'
import PropTypes from 'prop-types'

import ParkingInfoBox from './ParkingInfoBox'
import PriceMarker from './PriceMarker'

class ParkingMarker extends React.PureComponent {
    static propTypes = {
        parking: PropTypes.object,
        isSelected: PropTypes.bool,
        zIndex: PropTypes.number,
        selectParking: PropTypes.func,
        computeDistanceTo: PropTypes.func,
        buildParkingUrl: PropTypes.func,
        isMarked: PropTypes.bool,
    }

    static defaultProps = {
        isMarked: false,
    }

    onClick = this.onClick.bind(this)

    onClick () {
        const { selectParking, parking } = this.props
        selectParking(parking.entranceId)
    }

    render () {
        const {
            parking,
            isSelected,
            zIndex,
            isMarked,
            computeDistanceTo,
            buildParkingUrl,
        } = this.props

        if (!isSelected) {
            return (
                <PriceMarker
                  zIndex={zIndex}
                  parking={parking}
                  isMarked={isMarked}
                  onClick={this.onClick}
              />
            )
        }

        return (
            <ParkingInfoBox
              parking={parking}
              computeDistanceTo={computeDistanceTo}
              buildParkingUrl={buildParkingUrl}
            />
        )
    }
}

export default ParkingMarker
